// extracted by mini-css-extract-plugin
export default {"productContainer":"productList_productContainer__qRIuT","productList":"productList_productList__LaJbp"};